var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"fullscreen":_vm.fullscreen,"persistent":_vm.persistent,"overlay-opacity":"0.8","scrollable":_vm.scrollable,"max-width":_vm.maxWidth,"transition":_vm.fullscreen ? 'dialog-bottom-transition' : undefined},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }